import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fdt } from "@/lib/format";
import { Panel, SectionHead, SectionShell } from "./_shared";

export function LiveActivity() {
  const q = useQuery({
    queryKey: ["activities"],
    queryFn: async () => (await api.get("/activities?limit=12")).data,
    refetchInterval: 60000,
  });
  return (
    <Panel className="p-5 sm:p-6" data-testid="live-activity">
      <SectionHead eyebrow="What's Happening" title="Live activity" />
      <SectionShell query={q}>
        {(d) => {
          const items = d.items || [];
          if (items.length === 0) {
            return <p className="text-sm text-pawkt-text-secondary" data-testid="activity-empty">Your first business signal will appear here once activity begins.</p>;
          }
          return (
            <div className="relative space-y-0">
              {items.map((a, i) => (
                <div key={a.id} className="relative flex gap-3 pb-4 last:pb-0 animate-fade-in" style={{ animationDelay: `${Math.min(i, 8) * 45}ms` }}>
                  {/* rail */}
                  <div className="relative flex flex-col items-center">
                    <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary ring-4 ring-pawkt-primary-soft" />
                    {i < items.length - 1 && <span className="flex-1 w-px bg-pawkt-divider" />}
                  </div>
                  <div className="min-w-0 flex-1 -mt-0.5">
                    <p className="text-sm font-semibold text-pawkt-text leading-snug">{a.title}</p>
                    {a.description && <p className="truncate text-xs text-pawkt-text-secondary">{a.description}</p>}
                    <p className="text-[11px] text-pawkt-text-disabled mt-0.5">{fdt(a.created_at)}</p>
                  </div>
                </div>
              ))}
            </div>
          );
        }}
      </SectionShell>
    </Panel>
  );
}
